import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@material-ui/core"
import { useSelector } from 'react-redux';
import { DialogResponsive } from './DialogResponsive';
import CloseIcon from '@material-ui/icons/Close'; import { ImagineGrid as Grid } from '../../components'
import { useDispatch } from "react-redux"
import { infraStructureActions } from './../../actions';
import { SelectNew } from './SelectNew';
import { useTranslation } from 'react-i18next';



const useStyle = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: 'column'
  },
  modalWrapper: {
    padding: "2rem",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: "#FE9900",
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: 600,
    font: 'normal normal 600 20px/30px Poppins',
  },
  description: {
    textAlign: "left",
    fontSize: 16
  },
  bodyFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}))

export const DialogAddInfra = ({ open, id, type, typeDialog, handleClose }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(true)
  const { infraStructure } = useSelector((state) => state);
  const { newInfraStructure } = infraStructure;
  const { t } = useTranslation();

  function handleCloseButton() {

    dispatch(infraStructureActions.setNewInfraStructure({
      type: '',
      name: ''
    }));
    handleClose()
  }



  function handleYesButton() {
    const { type, body } = newInfraStructure;

    dispatch(infraStructureActions.postInfraStructure({ type, body }));

    handleClose()
  }

  function handleTypeInfra(value) {

    dispatch(infraStructureActions.setNewInfraStructure({
      type: value,
      name: newInfraStructure.body.name
    }));

  }
  function handleChangeName(value) {

    const timeout = setTimeout(() => {
      dispatch(infraStructureActions.setNewInfraStructure({
        type: newInfraStructure.type,
        name: value
      }));
    }, 1000)
    return () => clearTimeout(timeout)

  }


  useEffect(() => {

    if (!!newInfraStructure.body.name && !!newInfraStructure.type) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [newInfraStructure])

  useEffect(() => {
    dispatch(infraStructureActions.setNewInfraStructure({
      type: '',
      name: ''
    }));
  }, [dispatch])




  return (
    <DialogResponsive open={open}>
      {/* <form > */}
      <DialogContent className={classes.content}>
        <Grid container spacing={4}>

          <Grid item className={classes.titleWrapper}>
            <Typography variant="subtitle1" component="h3" className={classes.title}>
              {t('nova_infraestrutura')}
            </Typography>
            <CloseIcon onClick={handleCloseButton} />
          </Grid>
          <Grid item>
            <p className={classes.description}>{t('selecione_o_tipo_infraestrutuar_para_add')}</p>
          </Grid>
        </Grid>



        <SelectNew handle={handleTypeInfra} value={newInfraStructure.type} />
        <TextField
          style={{ width: '100%', maxWidth: 500 }}
          variant='filled'
          name="name"
          id="name"
          // value={newInfraStructure.body.name}
          label={t('nome_da_infraestrutura')}
          placeholder={t('adicione_o_nome_da_infraestrutura')}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          onChange={(e) => handleChangeName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Grid container spacing={4} cols={3}>
          <Grid item>
          </Grid>
          {/* <Grid item>
          </Grid> */}
          <Grid item>

          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              // loading={loading}
              onClick={handleYesButton}
              disabled={isDisabled}
            >
              {t('salvar_cadastro')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
      {/* </form> */}

    </DialogResponsive>
  )
}
